import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { getZaehlerMediumPreset } from '../../../functions/filterBundle';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../../../functions/validateField';
import { WActionButton } from '../../../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../../../core/table/WFormsTableWrapper';

export interface ZaehlerButtonWrapperProps {
    data: any;
    entity: string;
    field: string;
    isFormSaveDone?: boolean;
    item: any;
    layout?: string;
    onChange?: (entityName: string, data: any, callback?: () => void, timeout?: number, field?: any) => void;
    reloadBundle?: () => void;
    state?: any;
}

export interface ZaehlerButtonWrapperState {
    showDialog: boolean;
    zaehlerTid: number;
}

export class ZaehlerButtonWrapper extends React.Component<ZaehlerButtonWrapperProps, ZaehlerButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            zaehlerTid: null
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidUpdate(prevProps: any) {
        if (this.props.state !== prevProps.state && this.props.state) {
            this.setState({ ...(this.props.state || {}) });
        }
    }

    render(): JSX.Element {
        const item: any = this.props.item || {};
        const entity: string = this.props.entity || null;
        const field: string = this.props.field || null;
        const standort_tid: number = item.standort_tid_orig || item.standort_tid || null;
        const zaehlerTid: number = item[field] || parseInt(item[`${field}_name`]) || null;
        let styleProps: any = { marginLeft: 5, marginRight: 0 };

        if (['sidebysideComplex', 'sidebysideComplexGreen'].indexOf(this.props.layout) !== -1) {
            styleProps = { width: 20, height: 20, marginRight: 8 };
        }
        // Wenn das Speichern noch im Prozess ist, darf der Dialog nicht geöffnet werden
        if (!this.props.isFormSaveDone) {
            styleProps.backgroundColor = 'lightgray';
        }

        return <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {!!zaehlerTid &&
                    <WActionButton
                        tooltip='Zähler bearbeiten'
                        label='Zähler bearbeiten'
                        action='theme_edit'
                        key='btn_edit_zaehler'
                        styleProps={styleProps}
                        onAction={() => this.setState({ showDialog: true, zaehlerTid })}
                    />
                }
                <WActionButton
                    tooltip='Neuen Zähler anlegen'
                    label='Neuen Zähler anlegen'
                    action='add'
                    key='btn_add_zaehler'
                    styleProps={styleProps}
                    disabled={!this.props.isFormSaveDone}
                    onAction={() => this.setState({ showDialog: true, zaehlerTid: 0 })}
                />
            </div>
            {this.state.showDialog &&
                <DialogWrapper2 onAfterClose={() => this.setState({ showDialog: false })}>
                    <WFormsTableWrapper
                        entity={IDs.ENT_ZAEHLER}
                        module={IDs.MOD_ETOOL}
                        directEditFormularOf={{ tid: this.state.zaehlerTid }}
                        showDeleteInSaveDialog
                        customClass='Custom-ETA'
                        formLayout='flowV2'
                        onDelDone={(entityName: string, row: any): void => {
                            if (typeof this.props.reloadBundle === 'function') {
                                this.props.reloadBundle();
                            }
                            if ((row || {}).tid) {
                                item[field] = null;
                                item[`${field}_orig`] = null;
                                if (typeof this.props.onChange === 'function') {
                                    this.props.onChange(entity, item, null, 0);
                                }
                            }
                        }}
                        onSaveDone={(entityName: string, values: any, bundle: any, saveTid?: number) => {
                            if (typeof this.props.reloadBundle === 'function') {
                                this.props.reloadBundle();
                            }
                            // Beim Anlegen eines neuen Zählers wird dieser sofort ausgewählt.
                            if (saveTid > 0) {
                                item[field] = saveTid;
                                item[`${field}_orig`] = saveTid;
                                item[`${field}_name`] = values.zaehlernummer;
                                // Dazu noch Umstellung der Auswahlfelder _orig -> _tid...
                                if (item.standort_tid_orig > 0) {
                                    item.standort_tid = item.standort_tid_orig;
                                } else if (standort_tid) {
                                    item.standort_tid = standort_tid;
                                }
                                if (item.abrechnungsmodus_orig > 0) {
                                    item.abrechnungsmodus = item.abrechnungsmodus_orig;
                                }
                                if (item.abrechnungsart_orig > 0) {
                                    item.abrechnungsart = item.abrechnungsart_orig;
                                }
                                if (item.seperate_abrechnung_emobil_strom_orig > 0) {
                                    item.seperate_abrechnung_emobil_strom = item.seperate_abrechnung_emobil_strom_orig;
                                }
                                if (typeof this.props.onChange === 'function') {
                                    this.props.onChange(entity, item, null, 0);
                                }
                            }
                        }}
                        formPreset={{
                            standort: standort_tid,
                            medium: getZaehlerMediumPreset(entity)
                        }}
                        customFormConfig={{
                            standort: { readonly: true },
                            medium: { readonly: true }
                        }}
                        onAfterAction={(action: string) => {
                            if (action === 'closeForm') {
                                this.setState({ showDialog: null });
                            }
                        }}
                        validateField={(key: string, value: any, data: any, onValueChange) =>
                            validateFieldUniversal(IDs.ENT_ZAEHLER, key, value, data, onValueChange)
                        }
                    />
                </DialogWrapper2>
            }
        </>;
    }
}
